/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateUserIntentRequest} from '@cash-web/protos/squareup/cash/local/client/v1/local_user_intent.pb'
import {UpdateUserIntentResponse} from '@cash-web/protos/squareup/cash/local/client/v1/local_user_intent.pb'


export const updateUserIntent = (request: UpdateUserIntentRequest, options?: CashRequestOptions) => post<UpdateUserIntentRequest, UpdateUserIntentResponse>("/cash-app/local/user-intent/update", request, {...options, rejectOnError: true })